import { Address, Coordinates } from '@rygen/rygen-ui/model';

export class ShipmentEventLocation {
  addressLine1?: string;
  addressLine2?: string;
  addressLine3?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  country?: string = 'USA';
  coordinates?: Coordinates;
  timeZone?: string;

  constructor(opts?: Partial<ShipmentEventLocation>) {
    if (opts?.addressLine1 != null) {
      this.addressLine1 = opts.addressLine1;
    }
    if (opts?.addressLine2 != null) {
      this.addressLine2 = opts.addressLine2;
    }
    if (opts?.addressLine3 != null) {
      this.addressLine3 = opts.addressLine3;
    }
    if (opts?.city != null) {
      this.city = opts.city;
    }
    if (opts?.state != null) {
      this.state = opts.state;
    }
    if (opts?.postalCode != null) {
      this.postalCode = opts.postalCode;
    }
    if (opts?.country != null) {
      this.country = opts.country;
    }
    if (opts?.timeZone != null) {
      this.timeZone = opts.timeZone;
    }
    if (opts?.coordinates != null) {
      this.coordinates = new Coordinates(opts.coordinates);
    }
  }

  toAddress(): Address {
    return new Address({
      addressLine1: this.addressLine1,
      addressLine2: this.addressLine2,
      addressLine3: this.addressLine3,
      locality: this.city,
      region: this.state,
      postalCode: this.postalCode,
      country: this.country,
    });
  }
}
